import React from "react"
import { API_GATEWAY } from "aws-exports";
import { parseQueryString } from "lib/query-string";
import { useEffect } from "react";
import { Spinner } from "components";

export default function NewLoginScreen (props) {
    const { search } = props.location
    useEffect(() => {
        window.location.href = `${API_GATEWAY}/auth/shopify/install${search}`;
    }, [])
    return <Spinner />
}